"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _spacing = require("../../constants/spacing");
var _GridContainer = require("./styled/GridContainer");
const Grid = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    display = "grid",
    gap,
    template,
    children,
    renderAs,
    clientId,
    ...rest
  } = _ref;
  const GridContainerRoot = (0, _react.useMemo)(() => {
    return renderAs ? _GridContainer.GridContainer.withComponent(renderAs) : _GridContainer.GridContainer;
  }, [renderAs]);
  return /*#__PURE__*/_react.default.createElement(GridContainerRoot, (0, _extends2.default)({
    ref: ref,
    display: display,
    gap: gap === "none" ? 0 : _spacing.sizes[gap],
    template: template,
    "data-client-id": clientId
  }, rest), children);
});
exports.Grid = Grid;
Grid.displayName = "Grid";
//# sourceMappingURL=Grid.js.map